var map = {
	"./co2.jpg": 823,
	"./coal.jpg": 824,
	"./crude_oil.jpg": 825,
	"./foresight.jpg": 826,
	"./gas.jpg": 827,
	"./gasCrisis.jpg": 828,
	"./homepage.jpg": 397,
	"./oil.jpg": 829,
	"./powerplant.jpg": 830,
	"./renouvelables.jpg": 831,
	"./total.jpg": 832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 822;